import React from 'react'

const BorderWrapper = ({
    children, 
    wrapperClass, 
    className,
  }: {
    children: React.ReactNode, 
    wrapperClass?: string, 
    className?: string,
  }) => {
  return (
    <div className={`bg-[linear-gradient(0deg,_#121124_0%,_#353353_100%)] p-[1px] ${wrapperClass} `}>
        <div className={`${className}`}>
          {children}
        </div>
    </div>
  )
}

export default BorderWrapper;